import { render, staticRenderFns } from "./serviceRemark.vue?vue&type=template&id=aa24964a&scoped=true"
import script from "./serviceRemark.vue?vue&type=script&lang=js"
export * from "./serviceRemark.vue?vue&type=script&lang=js"
import style0 from "./serviceRemark.vue?vue&type=style&index=0&id=aa24964a&prod&scoped=true&lang=css"
import style1 from "./serviceRemark.vue?vue&type=style&index=1&id=aa24964a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa24964a",
  null
  
)

export default component.exports